// import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";
import {
    Form,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    Checkbox, Row, Col
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { Map, Marker, InfoWindow } from 'google-maps-react';
import place_red from '../../image/3.png';
import { addStore, deleteImg, updateBrand } from "./service";
import { getProvince, getDistrict, getSubDistrict, getTerritory, getBrand } from "./../service";

const { Option } = Select;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 16 },
        lg: { span: 12 },
    },
};

String.prototype.ucFirst = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0
        },
        sm: {
            span: 16,
            offset: 8
        }
    }
};
const tailFormItemLayout2 = {
    wrapperCol: {
        xs: {
            span: 0,
            offset: 0
        },
        sm: {
            span: 0,
            offset: 0
        }
    }
};

var place_red_resize = null;

const google = window.google
const mapStyles = {
    width: '100%',
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
};
const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
        onSuccess("ok");
    }, 0);
};

function success() {
    let secondsToGo = 3;
    const onOkModal = () => {
        window.location.reload();
    }
    const modal = Modal.success({
        title: 'แก้ไขข้อมูลร้านค้า เรียบร้อยแล้ว!',
        // content: `This modal will be destroyed after1 ${secondsToGo} second.`,
        // closable: true,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
        // modal.update({
        //     content: `This modal will be destroyed after2 ${secondsToGo} second.`,
        // });
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
        window.location.reload();
    }, secondsToGo * 1000);
}
function error(message) {
    let secondsToGo = 3;
    const onOkModal = () => {
        modal.destroy();
    }
    const modal = Modal.warning({
        title: "Error: " + message,
        okText: 'OK',
        onOk: () => {
            onOkModal()
        },
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
        clearInterval(timer);
    }, secondsToGo * 1000);
}
const Editform = (props) => {
    const [form] = Form.useForm();
    const [markers, setMarkers] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [previewTitle, setPreviewTitle] = useState('')
    const [fileList, setFileList] = useState([])
    const [lat, setLat] = useState('')
    const [lng, setLng] = useState('')
    const [load, setLoad] = useState(true)

    const [dataProvince, setDataProvince] = useState([])
    const [provinceID, setProvinceID] = useState('')
    const [provinceName, setProvinceName] = useState('')
    const [dataDistrict, setDataDistrict] = useState([])
    const [districtID, setDistrictID] = useState('')
    const [districtName, setDistrictName] = useState('')
    const [dataSubDistrict, setDataSubDistrict] = useState([])
    const [subDistrictID, setSubDistrictID] = useState('')
    const [subDistrictName, setSubDistrictName] = useState('')
    const [postCode, setPostCode] = useState('')
    const [dataTerritory, setDataTerritory] = useState([])
    const [saleAreaCd, setSaleAreaCd] = useState('')
    const [saleAreaDesc, setSaleAreaArea] = useState('')
    const [userLevel, setUserLevel] = useState()

    const [brandData, setBrandData] = useState([])

    useEffect(() => {
        // console.log("mount it props.storeDetail!", props);
        setUserLevel(props.userLevel)
        function setLoadEffect() {
            setLoad(false)
        }
        function getStoreImg() {
            var temp_img = []
            if (props.storeDetail.storeimage.length > 0) {
                // console.log("props.storeDetail.storeimage > 0");
                props.storeDetail.storeimage.map((img, index) => (
                    temp_img.push({
                        uid: props.storeDetail.storeimage[index].id + 'profile',
                        name: 'temp_profile',
                        // uid: props.storeDetail.storeimage[index].id,
                        // name: props.storeDetail.storeimage[index].filename,
                        status: 'done',
                        url: props.storeDetail.storeimage[index].url_path,
                    })
                ))
                setFileList(temp_img)
            }
            setProvinceID(props.storeDetail.provinceID)
            setDistrictID(props.storeDetail.amphurID)
            setSubDistrictID(props.storeDetail.tumbonID)
            // console.log("temp_img===", temp_img);
            setLoadEffect()
        }
        function getBrandData() {
            getBrand().then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setBrandData(res.data.info)
                }
            })
            setLoadEffect()
        }
        function getData() {
            getProvince().then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setDataProvince(res.data)
                }
            })
            getTerritory().then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setDataTerritory(res.data)
                }
            })
            getBrandData()
            // setLoadEffect()
        }
        getData();
        getStoreImg();
        setLat(storeDetail.latitude);
        setLng(storeDetail.longitude);
        setSaleAreaCd(storeDetail.saleAreaCd);
        setSaleAreaArea(storeDetail.saleAreaDesc);
    }, [props]);
    const onChange = (checkedValues) => {
        // console.log('checked = ', checkedValues);
    }
    const handleCancel = () => setPreviewVisible(false)
    const handlePreview = async file => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }

        // this.setState({
        setPreviewImage(file.url || file.preview)
        setPreviewVisible(true)
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
        // });
    };
    const handleChange = ({ fileList }) => {
        setFileList(fileList)
    }
    const handleRemove = (e) => {
        // setFileList(fileList)
        let data = {
            "url": e.url
        };
        console.log("handleRemove===", e)
        deleteImg(data).then(res => {
            console.log("res===", res)
            // if (res && res.status === 200) {
            //     success()
            // }
        })
    }

    const selectArea = (e, name) => {
        setSaleAreaCd(e)
        setSaleAreaArea(name.territoryname)
    }
    const optionArea = (
        // const [saleAreaCd, setSaleAreaCd] = useState('')
        // const [saleAreaArea, setSaleAreaArea] = useState('')
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectArea}
        >
            {
                dataTerritory.map((data, index) => {
                    // console.log("dataTerritory", dataTerritory)
                    return (
                        <Option key={index} value={data.tID} territoryname={data.territory}>{data.territory}</Option>
                    );
                })
            }
        </Select>
    )
    const onFinish = (values) => {
        // console.log("Received values of form: ", values);
        const formData = new FormData();
        const formBrandData = new FormData();
        formBrandData.append('storeCd', values.store_code);
        var postCode1 = postCode
        if (postCode === '') {
            postCode1 = values.postal_code
        } else {
            postCode1 = postCode
        }


        if (fileList.length > 0) {
            fileList.forEach((item, index) => {
                if (fileList[index].name.includes('temp_profile')) {

                } else {
                    formData.append(`image[${index}]`,
                        item.originFileObj
                    );
                }
            });
            formData.append('state', 'update');
            if (values.brand) {
                values.brand.forEach((item, index) => {
                    formBrandData.append(`brand[${index}]`,
                        item
                    );
                });
            }
            // console.log("postCode1", postCode1);
            formData.append('store_name', values.store_name);
            formData.append('id', storeDetail.id);
            formData.append('storeCd', values.store_code);
            formData.append('address', values.address);
            formData.append('postal_code', postCode1);
            formData.append('phone', values.phone);
            formData.append('taxID', values.taxID);
            formData.append('contact_name', values.contact_name);
            formData.append('contact_phone', values.contact_phone);
            if (lat) {
                formData.append('latitude', lat);
                formData.append('longitude', lng);
            } else {
                formData.append('latitude', storeDetail.latitude);
                formData.append('longitude', storeDetail.longitude);
            }
            formData.append('provinceID', provinceID);
            formData.append('amphurID', districtID);
            formData.append('tumbonID', subDistrictID);
            formData.append('saleAreaCd', saleAreaCd);
            formData.append('saleAreaDesc', saleAreaDesc);
        } else {
            formData.append('state', 'update');
            if (values.brand) {
                values.brand.forEach((item, index) => {
                    formBrandData.append(`brand[${index}]`,
                        item
                    );
                });
            }
            formData.append('store_name', values.store_name);
            formData.append('id', storeDetail.id);
            formData.append('storeCd', values.store_code);
            formData.append('address', values.address);
            formData.append('postal_code', postCode1);
            formData.append('phone', values.phone);
            formData.append('taxID', values.taxID);
            formData.append('contact_name', values.contact_name);
            formData.append('contact_phone', values.contact_phone);
            if (lat) {
                formData.append('latitude', lat);
                formData.append('longitude', lng);
            } else {
                formData.append('latitude', storeDetail.latitude);
                formData.append('longitude', storeDetail.longitude);
            }
            formData.append('provinceID', provinceID);
            formData.append('amphurID', districtID);
            formData.append('tumbonID', subDistrictID);
            formData.append('saleAreaCd', saleAreaCd);
            formData.append('saleAreaDesc', saleAreaDesc);
        }
        updateBrand(formBrandData)
        addStore(formData).then(res => {
            if (res && res.status === 200) {
                updateBrand(formBrandData).then(res => {
                    success()
                })
            } else {
                error(res)
            }
        })
    };

    const prefixSelector = (
        <Form.Item name="prefix" noStyle>
            <Select style={{ width: 70 }}>
                <Option value="+66">+66</Option>
                {/* <Option value="87">+87</Option> */}
            </Select>
        </Form.Item>
    );
    // console.log("props", props.storeDetail)
    const storeDetail = props.storeDetail
    const showMarkers = () => {
        // return this.state.shopSearch.map((store, index) => {
        // console.log("store", store)

        return <Marker position={{
            lat: storeDetail.latitude,
            lng: storeDetail.longitude
        }}
            valuename={storeDetail.store_name}
            valuephone={storeDetail.phone1}
            valueaddress={storeDetail.full_address}
            valuefn={storeDetail.firstName_th}
            valueln={storeDetail.lastName_th}
        // valuestore={store}
        // onClick={onMarkerClick}
        />

        // })
    }
    const onMapClick = (t, map, coord) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();

        // console.log(lat);
        // console.log(lng);
        setLat(lat);
        setLng(lng);

        let tmp = [];
        clearmap();

        // resize image for marker
        place_red_resize = { url: place_red, scaledSize: new google.maps.Size(30, 45) };

        // add marker
        var marker = new google.maps.Marker({
            position: latLng,
            map: map,
            icon: place_red_resize,
        });
        map.panTo(latLng);

        // add new marker to state
        tmp.push(marker);
        // console.log(tmp)
        setMarkers(tmp)

        // add infowindow
        var infowindow = new google.maps.InfoWindow({
            content: "hello"
        });

        // declare event click to marker
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }

    const clearmap = () => {
        // console.log('clearmap')
        for (var i = 0; i < markers.length; i++) {
            setMarkers(markers[i].setMap(null));		//clear acc marker on map
        }
    }

    const uploadButton = (
        <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const dd = () => {
        console.log("selectDistrict", dataDistrict, districtName, provinceName, postCode)
    }

    const propsUpload = {
        onRemove: file => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            return {
                fileList: newFileList,
            };
        },
        beforeUpload: file => {
            setFileList(fileList, file)
            return false;
        },
    };

    const selectProvince = (e, name) => {
        // console.log("value", e)
        // console.log("name", name.provincename)
        setProvinceID(e)
        setProvinceName(name.provincename)
        function getData() {

            getDistrict(e).then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setDataDistrict(res.data)
                }
            })
        }
        getData();
    }
    const optionProvince = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectProvince}
        >
            {
                dataProvince.map((data, index) => {
                    return (
                        <Option key={index} value={data.provinceID} provincename={data.provincename}>{data.provincename}</Option>
                    );
                })
            }
        </Select>
    )
    const selectDistrict = (e, name) => {
        // console.log("value", e)
        // console.log("name", name.districtname)
        setDistrictID(e)
        setDistrictName(name.districtname)
        function getData() {
            getSubDistrict(e).then(res => {
                // console.log("res===", res)
                if (res && res.status === 200) {
                    setDataSubDistrict(res.data)
                }
            })
        }
        getData();
    }
    const optionDistrict = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectDistrict}
        >
            {
                dataDistrict.map((data, index) => {
                    return (

                        <Option key={index} value={data.amphurID} districtname={data.amphurname}>{data.amphurname}</Option>
                    );
                })
            }
        </Select>
    )
    const selectSubDistrict = (e, name) => {
        // console.log("value", e)
        // console.log("name", name)
        setSubDistrictID(e)
        setSubDistrictName(name.subdistrictname)
        setPostCode(name.postcode)
        // function getData() {
        //     getSubDistrict(e).then(res => {
        //         console.log("res===", res)
        //         if (res && res.status === 200) {
        //             setDataSubDistrict(res.data)
        //         }
        //     })
        // }
        // getData();        
    }
    const optionSubDistrict = (
        <Select
            showSearch
            style={{ width: '100%' }}
            placeholder="Search to Select"
            optionFilterProp="children"
            filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
                optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }
            onChange={selectSubDistrict}
        >
            {
                dataSubDistrict.map((data, index) => {
                    return (
                        <Option key={index} value={data.TambonID} subdistrictname={data.TambonThai} postcode={data.PostCode}>{data.TambonThai}</Option>
                    );
                })
            }
        </Select>
    )

    const changePostCode = (e, name) => {
        setPostCode(e.target.value)
    }
    const inputPostCode = (
        <div>
            <Input value={postCode} onChange={changePostCode} />
        </div>
    )
    return (
        <div>
            {/* <Button onClick={dd}>dd</Button> */}
            <Form
                {...formItemLayout}
                form={form}
                name="editShop"
                id="editShop"
                onFinish={onFinish}
                initialValues={{
                    prefix: "+66",
                    store_name: storeDetail.store_name,
                    store_code: storeDetail.storeCd,
                    phone: storeDetail.phone1,
                    taxID: storeDetail.taxID,
                    address: storeDetail.address1,
                    subDistrict: storeDetail.subDistrict,
                    district: storeDetail.district,
                    province: storeDetail.province,
                    postal_code: storeDetail.postal_code,
                    contact_name: storeDetail.contact_name,
                    contact_phone: storeDetail.contact_phone,
                    latitude: storeDetail.latitude,
                    longitude: storeDetail.longitude,
                    area: storeDetail.saleAreaCd,
                    brand: storeDetail.brand
                }}
                scrollToFirstError
            >
                <Form.Item
                    label="รูปร้านค้า"
                >
                    <Upload {...propsUpload}
                        listType="picture-card"
                        fileList={fileList}
                        onPreview={handlePreview}
                        onChange={handleChange}
                        customRequest={dummyRequest}
                        onRemove={handleRemove}
                        rowKey={fileList}
                        style={{ padding: '0px' }}

                    >
                        {fileList.length >= 6 ? null : uploadButton}
                    </Upload>
                    <Modal
                        visible={previewVisible}
                        title={previewTitle}
                        footer={null}
                        onCancel={handleCancel}
                    >
                        <img style={{ width: '100%' }} src={previewImage} />
                    </Modal>
                </Form.Item>
                <Form.Item
                    name="store_code"
                    label="รหัสร้านค้า"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ รหัสร้านค้า!",
                        }
                        // ,
                        // {
                        //     pattern: /^[\d]{13}$/,
                        //     message: "กรุณาระบุ เป็นตัวเลข 13 หลัก",
                        // }
                    ]}
                >
                    {/* <Input disabled={userLevel == 99 ? false : true} /> */}
                    <Input disabled={true} />
                </Form.Item>
                <Form.Item
                    name="store_name"
                    label="ชื่อร้านค้า"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ ชื่อร้านค้า!",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="phone"
                    label="เบอร์โทรศัพท์ร้านค้า"
                    rules={[{
                        required: true,
                        message: "กรุณาระบุ เบอร์โทรศัพท์ร้านค้า!"
                    }]}
                >
                    <Input style={{ width: "100%" }} />
                </Form.Item>
                <Form.Item
                    name="taxID"
                    label="เลขประจำตัวผู้เสียภาษี"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เลขประจำตัวผู้เสียภาษี!",
                        },
                        {
                            pattern: /^[\d]{13}$/,
                            message: "กรุณาระบุ เป็นตัวเลข 13 หลัก",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="address"
                    label="เลขที่ / ถนน"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เลขที่ / ถนน!",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="province"
                    label="จังหวัด"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ จังหวัด!",
                        }
                    ]}
                >
                    {/* <Input /> */}
                    {optionProvince}
                </Form.Item>
                <Form.Item
                    name="district"
                    label="อำเภอ"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ อำเภอ!",
                        }
                    ]}
                >
                    {optionDistrict}
                </Form.Item>
                <Form.Item
                    name="subDistrict"
                    label="ตำบล"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ ตำบล!",
                        }
                    ]}
                >
                    {optionSubDistrict}
                </Form.Item>
                <Form.Item
                    name="postal_code"
                    label="รหัสไปรษณีย์"
                    // rules={[
                    //     {
                    //         required: true,
                    //         message: "กรุณาระบุ รหัสไปรษณีย์!",
                    //     },
                    //     {
                    //         pattern: /^[\d]{0,5}$/,
                    //         message: "กรุณาระบุ เป็นตัวเลข 5 หลัก",
                    //     }
                    // ]}
                >
                    {/* {inputPostCode} */}
                    {postCode ? inputPostCode : <Input />}
                    {/* <Input /> */}
                </Form.Item>
                <Form.Item
                    name="contact_name"
                    label="ชื่อผู้ติดต่อ"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ ชื่อผู้ติดต่อ!",
                        }
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name="contact_phone"
                    label="เบอร์โทรผู้ติดต่อ"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เบอร์โทรผู้ติดต่อ!",
                        }
                    ]}
                >
                    <Input style={{ width: "100%" }} />
                </Form.Item>
                {brandData.length > 0 &&
                    <Form.Item
                        name="brand"
                        label="กรุ๊ปแบรนด์"
                    >
                        <Checkbox.Group style={{ width: '100%' }} onChange={onChange}>
                            <Row>
                                {brandData.map((data, index) => {
                                    return (
                                        <Col key={index} span={8}>
                                            <Checkbox value={data.brand_name} brand_name={data.brand_name}>{data.brand_name}</Checkbox>
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Checkbox.Group>
                    </Form.Item>
                }
                <Form.Item
                    name="area"
                    label="เขตการขาย"
                    rules={[
                        {
                            required: true,
                            message: "กรุณาระบุ เขตการขาย!",
                        }
                    ]}
                >

                    {optionArea}
                </Form.Item>
                {lat ?
                    <Form.Item
                        label="latitude"
                        rules={[
                            {
                                required: true,
                                message: "Please input your shop Latitude!",
                            }
                        ]}
                    >
                        <Input value={lat} />
                    </Form.Item>
                    :
                    <Form.Item
                        name="latitude"
                        label="latitude"
                        rules={[
                            {
                                required: true,
                                message: "Please input your shop Latitude!",
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                }
                {lng ?
                    <Form.Item
                        label="longitude"
                        rules={[
                            {
                                required: true,
                                message: "Please input your shop Longitude!",
                            }
                        ]}
                    >
                        <Input value={lng} />
                    </Form.Item>
                    :
                    <Form.Item
                        name="longitude"
                        label="longitude"
                        rules={[
                            {
                                required: true,
                                message: "Please input your shop Longitude!",
                            }
                        ]}
                    >
                        <Input />
                    </Form.Item>
                }
                <Form.Item
                    {...tailFormItemLayout2}
                >
                    <div style={{ height: '250px' }}>
                        <Map
                            google={google}
                            zoom={15}
                            style={mapStyles}
                            initialCenter={{ lat: storeDetail.latitude, lng: storeDetail.longitude }}
                            // onReady={onMapReady.bind(this)}
                            onClick={onMapClick.bind(this)}
                            disableDefaultUI
                            zoomControl
                        >
                            {lat && showMarkers()}
                        </Map>
                    </div>
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" style={{ float: 'right' }}>
                        แก้ไขข้อมูลร้านค้า
                </Button>
                </Form.Item>
            </Form>
        </div >
    );
};

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export default Editform